<script lang="ts">
    import {onMount} from "svelte";
    import {api, loader, swClient, toast} from "../stores";
    import type {Campaign, Operation} from "../model";
    import {Types} from "../model";
    import moment from 'moment';

    let campaigns: Operation[] = [];
    let allCampaigns: Operation[] = [];

    let topDateRange: string = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');

    let bottomDateRange: string = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');

    /**Options and value for the type of operation*/
    const operationTypeValues: string[] = [
        "Tous les types",
        "Nationale",
        "Régionale",
        "Locale",
        "Mixte",
    ];
    let operationTypeFilterValue: string = "Tous les types";

    /**Options and value for the centrale names*/
    const centralesValues: string[] = ["Toutes les centrales"];
    let centraleFilterValue: string = "Toutes les centrales";

    /** debounce timer for search */
    let timer: NodeJS.Timeout = null;

    /**The value in the search bar*/
    let searchValue: string;

    /** is the component init ?*/
    let isInit: boolean = false;

    /** is the component init ?*/
    let currentCampaign: Operation = null;

    let centraleModal;
    let documentModal;
    let productModal;
    let isModalOpen: boolean = false;

    let displayWarningMsg: boolean = true;
    let warningMsg: string = "Utilisez le bouton Rechercher pour charger les opérations.";

    const compagnyMatch = {
        'SCAPEST': '6231',
        'SCADIF': '6226',
        'SCAOUEST': '30818',
        'SOCAMAINE': '6236',
        'SCASO': '40028',
        'SOCAMIL': '6237',
        'SCANORMANDE': '13779',
        'SCAPALSACE': '7920',
        'SCACENTRE': '13778',
        'SC GALEC': '6158',
        'SCAPNOR': '20749',
        'LECASUD': '6167',
        'SC GALEC - BRICO/JARDIN': '51730',
        'SOCARA': '6238',
        'SCACHAP': '6225',
        'SC GALEC - SPORT ET LOISIRS': '51731',
        'SCAPARTOIS': '15336',
        'SC GALEC - Auto': '51732',
        'BTLEC EST': '37830',
        'SC GALEC - PARA-PHARMACIE': '51733',
        'SCARMOR': '6232',
        'SC GALEC - Culturel': '51734',
        'SCALANDES': '6227',
        'SC GALEC - OPTIQUE': '51735',
        'DEVINLEC - Bijouterie': '31780',
        'SCAOUEST_BTLEC': '52406',
        'SC GALEC - Drive': '51736',
        'SC GALEC - UNE HEURE POUR SOI': '52473',
        'LECLERC VOYAGES': '31834',
        'SC GALEC - GT JOUETS': '68247',
    };

    const scaMatch = {
        'A': 'SCAPNOR',
        'B': 'SCADIF',
        'C': 'SCAPEST',
        'D': 'SCARMOR',
        'E': 'SCAOUEST',
        'F': 'SOCAMAINE',
        'G': 'SCACHAP',
        'H': 'SCASO',
        'I': 'SOCAMIL',
        'J': 'LECASUD',
        'K': 'SOCARA',
        'L': 'SCANORMANDE',
        'N': 'SCAPALSACE',
        'O': 'SCACENTRE',
        'R': 'SCALANDES',
        'S': 'SCAPARTOIS',
    };

    let getCampaignsNumber = 0;

    onMount(async () => {
        isInit = false;
        const geoAreas = await $swClient.get(`/v2/geoareas`);
        for (let i = 0; i < geoAreas.length; i++) {
            const geoArea = geoAreas[i];
            // init centrale Values
            centralesValues.push(geoArea.name);
        }
        // await getCampaigns();
        isInit = true;
    });

    function getCampaigns() {
        let processId = $loader.show('Chargement des campagnes');
        isInit = false;
        campaigns = [];
        allCampaigns = []
        return $swClient.getCampaigns().then(
            async (res: Campaign[]) => {
                let temp_campaigns = [];
                let camps = _formatAndFilterCampaigns(res);
                for (let i = 0; i < camps.length; i++) {
                    $loader.hide(processId);
                    processId = $loader.show(`Chargement informations des campagnes : ${i}/${camps.length - 1}`);

                    const orders = await $swClient.getOrdersByCampaign(camps[i].uid);
                    // only campaign with order
                    if (orders.length > 0) {

                        let camp = camps[i];

                        (camp as any).shops = orders.length;

                        if (new Date(camp.startDate) > new Date(bottomDateRange) && new Date(camp.startDate) < new Date(topDateRange)) {
                            //getproducts pour pouvoir faire le digital only
                            const products = await $swClient.getProductsByCampaign(camp.uid);
                            const ecatOnlyProducts = products.filter((prod) => {
                                let isEcatOnly: boolean = false;
                                for (let j = 0; j < prod.dataset.length; j++) {
                                    const dt = prod.dataset[j];
                                    if (dt.name === "ecatOnly") {
                                        isEcatOnly = JSON.parse(dt.value);
                                        break;
                                    }
                                }
                                return isEcatOnly;
                            });
                            (camp as any).num_ecatOnly_products = ecatOnlyProducts.length;


                            //get documentsByCampaign pour les centrales
                            let documents = await $swClient.getDocumentsByCampaign(camp.uid);

                            // remove document without order
                            for (let order of orders) {
                                let founded = false;
                                let index = 0;
                                for (const [i, document] of documents.entries()) {
                                    if (order.document_uid === document.uid) {
                                        founded = true;
                                        index = i;
                                        break;
                                    }
                                }
                                if (!founded) {
                                    documents = [...documents.slice(0, i), ...documents.slice(i + 1)];
                                }
                            }

                            const centrales = documents
                                .map((doc) => {
                                    return doc.geo_area.name;
                                })
                                .filter((cen) => cen !== "");

                            if (camp.type == 'Mixte') {
                                const productsByCentrale = {};
                                let natProds = 0;
                                for (let j = 0; j < products.length; j++) {
                                    const prod = products[j];
                                    const productGeoArea = prod.geo_area.name;
                                    if (productGeoArea) {
                                        if (!productsByCentrale[productGeoArea]) {
                                            productsByCentrale[productGeoArea] = 0;
                                        }
                                        productsByCentrale[productGeoArea]++;
                                    } else {
                                        natProds++
                                    }
                                }
                                (camp as any).natProds = natProds;
                                (camp as any).productsByCentrale = productsByCentrale;
                            }

                            (camp as any).invoiceType = !camp.is_paf ? 'ecat' : products.length > 0 ? 'paf' : 'ppp';
                            // set packs for documents
                            for (let j = 0; j < documents.length; j++) {
                                const doc = documents[j];
                                let pack3 = 0;
                                let pack5 = 0;
                                let pack6 = 0;
                                for (let k = 0; k < products.length; k++) {
                                    const prod = products[k];
                                    let datasetDoc = [];
                                    let datasetPack = [];
                                    for (let l = 0; l < prod.dataset.length; l++) {
                                        if (prod.dataset[l].name == 'vitesses' && prod.dataset[l].value != '') {
                                            datasetDoc = JSON.parse(prod.dataset[l].value);
                                        } else if (prod.dataset[l].name == 'trade' && prod.dataset[l].value != '') {
                                            datasetPack = JSON.parse(prod.dataset[l].value);
                                        }
                                    }
                                    if (datasetPack && datasetDoc && datasetDoc.includes(doc.name)) {
                                        if ((typeof datasetPack == 'object') && datasetPack.includes(3)) {
                                            pack3++;
                                        }
                                        if ((typeof datasetPack == 'object') && datasetPack.includes(5)) {
                                            pack5++;
                                        }
                                        if ((typeof datasetPack == 'object') && datasetPack.includes(6)) {
                                            pack6++;
                                        }
                                    }
                                }
                                (documents[j] as any).pack3 = pack3;
                                (documents[j] as any).pack5 = pack5;
                                (documents[j] as any).pack6 = pack6;
                            }

                            (camp as any).centrales = [...new Set(centrales)]; // remove duplicates
                            (camp as any).documents = documents;
                            allCampaigns.push(camp);
                            temp_campaigns.push(camp);
                        }
                    }
                }
                campaigns = temp_campaigns;
                console.log(campaigns);
                displayWarningMsg = false;
                isInit = true;
                search();
                $loader.hide(processId);
            },
            (err) => {
                console.error(err);
                isInit = true;
                $loader.hide(processId);
            }
        );
    }

    function _formatCampaign(item) {
        let campaign: Operation = {
            uid: item.uid,
            name: item.name.replace(/(\r\n|\n|\r)/gm, ""),
            type: item.type.name,
            geo_area: item.geo_area,
            is_paf: false,
            show_paf: true,
            campaign: item,
        };
        for (let j = 0; j < item.attrs.length; j++) {
            const attr = item.attrs[j];
            if (attr.key === Types.campaign.attrs.code) {
                campaign.code = attr.value;
            }
            if (attr.key === Types.campaign.attrs.is_paf) {
                campaign.is_paf = attr.value;
            }
            if (attr.key === Types.campaign.attrs.show_paf) {
                campaign.show_paf = attr.value;
            }
        }
        for (let j = 0; j < item.milestones.length; j++) {
            const milestone = item.milestones[j];
            if (milestone.name === Types.campaign.milestones.start_date) {
                campaign.startDate = milestone.date;
            }
            if (milestone.name === Types.campaign.milestones.end_date) {
                campaign.endDate = milestone.date;
            }
            if (milestone.name === Types.campaign.milestones.display_date) {
                campaign.displayDate = milestone.date;
            }
        }
        return campaign;
    }

    function _formatAndFilterCampaigns(items) {
        const res = [];
        for (let i = 0; i < items.length; i++) {
            let camp = _formatCampaign(items[i])
            if (new Date(camp.startDate) > new Date(bottomDateRange) && new Date(camp.startDate) < new Date(topDateRange)) {
                res.push(camp);
            }
        }
        return res;
    }

    function exportInvoice() {
        if (campaigns.length > 0) {
            const header = ['code_op', 'nom', 'date_debut', 'date_fin', 'vitesse', 'client', 'code_client', 'type', 'nb_page', 'pack3', 'pack5', 'pack6'];
            const items = _formatForInvoice(campaigns);
            items.unshift(header);
            const jsonObject = JSON.stringify(items);
            const csv = _convertToCSV(jsonObject);
            const exportedFilenmane = `export_facture_${new Date().toISOString()}.csv`;
            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});

            const link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmane);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            $toast.error("Aucune campagne dans la liste.");
        }
    }

    function exportCSV() {
        if (campaigns.length > 0) {
            const items = _formatForCSV(campaigns);
            const header = ['code', 'nom', 'type', 'Feuillatable', 'nb_vitesses', 'date_debut', 'date_fin', 'magasins', 'pages_par_document',
                'totalPages', 'centrales', 'nb_produits', 'nb_produits_digitaux', 'nb_produits_nationaux', 'nb_produits_par_centrale'
            ];
            items.unshift(header);

            // Convert Object to JSON
            const jsonObject = JSON.stringify(items);

            const csv = _convertToCSV(jsonObject);

            const exportedFilenmane = `statistics_${new Date().toISOString()}.csv`;

            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});

            const link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmane);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            $toast.error("Aucune campagne dans la liste.");
        }
    }

    function _convertToCSV(objArray) {
        const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = '';

        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in array[i]) {
                if (line != '') line += ';'

                line += array[i][index];
            }
            str += line + '\r\n';
        }
        return str;
    }

    function _formatForCSV(campaigns: Operation[]): any[] {
        return campaigns.map(campaign => {
            let myObject = {
                code: campaign.code,
                nom: campaign.name,
                type: campaign.type,
                feuilletable: campaign.is_paf ? "Oui" : "Non",
                nb_vitesses: campaign.campaign.num_documents,
                date_debut: moment(campaign.startDate).format("DD/MM/YYYY"),
                date_fin: moment(campaign.endDate).format("DD/MM/YYYY"),
                magasins: (campaign as any).shops,
                pages_par_document: JSON.stringify((campaign as any).documents.map(doc => `${doc.name} : ${doc.pages.length}`)),
                totalPages: (campaign as any).documents.reduce((partialSum, doc) => partialSum + doc.pages.length, 0),
                centrales: (campaign as any).centrales.join(','),
                nb_produits: campaign.campaign.num_products,
                nb_produits_digitaux: (campaign as any).num_ecatOnly_products,
            }
            if (campaign.type === 'Mixte') {
                const prodByCentrales = Object.keys(campaign['productsByCentrale']).sort();
                (myObject as any).nb_produits_nationaux = (campaign as any).natProds;
                (myObject as any).nb_produits_par_centrale = JSON.stringify(prodByCentrales.map(centrale => `${centrale} : ${campaign['productsByCentrale'][centrale]}`));
            }
            return myObject;
        });
    }

    function _formatForInvoice(campaigns: Operation[]): any[] {
        const mappedCampaign = [];
        for (let i = 0; i < campaigns.length; i++) {
            const camp = campaigns[i];
            for (let j = 0; j < (camp as any).documents.length; j++) {
                const doc = (camp as any).documents[j];
                const customer: { name: string, code: string } = _findCustomer(doc.name);
                let name = camp.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                name = name.replace(/N°/g, 'NUMERO ');
                name = name.replace(/n°/g, 'numero ');
                name = name.replace(/°/g, ' ');
                let myObject = {
                    code_op: camp.code,
                    nom: name,
                    date_debut: moment(camp.startDate).format("DD/MM/YYYY"),
                    date_fin: moment(camp.endDate).format("DD/MM/YYYY"),
                    vitesse: doc.name,
                    client: customer.name,
                    code_client: customer.code,
                    type: (camp as any).invoiceType,
                    nb_page: doc.pages.length,
                    pack3: doc.pack3,
                    pack5: doc.pack5,
                    pack6: doc.pack6,
                }
                mappedCampaign.push(myObject);
            }
        }
        return mappedCampaign;
    }

    function _findCustomer(documentName: string): { name: string, code: string } {
        documentName = documentName.trim();
        documentName = documentName.split("_")[0];
        const thirdLetter = documentName[2];
        let compagny: string = "";
        switch (thirdLetter) {
            case 'G' :
                const seventhLetter = documentName[6];
                switch (seventhLetter) {
                    case 'A' :
                        compagny = 'SC GALEC - Auto';
                        break;
                    case 'H' :
                        compagny = 'SC GALEC - GT JOUETS';
                        break;
                    case 'J' :
                        compagny = 'SC GALEC - BRICO/JARDIN';
                        break;
                    case 'O' :
                        compagny = 'SC GALEC - OPTIQUE';
                        break;
                    case 'P' :
                        compagny = 'SC GALEC - PARA-PHARMACIE';
                        break;
                    case 'Q' :
                        compagny = 'SC GALEC - Culturel';
                        break;
                    case 'S' :
                        compagny = 'SC GALEC - SPORT ET LOISIRS';
                        break;
                    case 'V' :
                        compagny = 'LECLERC VOYAGES';
                        break;
                    case 'E' :
                        compagny = 'SC GALEC';
                        break;
                    case 'G' :
                        if (documentName.length == 7) {
                            compagny = 'SC GALEC';
                        } else if (documentName.length > 7) {
                            const scaLetter = documentName[7];
                            compagny = scaMatch[scaLetter];
                        }
                        break;
                }
                break;
            case 'O' :
                compagny = 'SCAOUEST_BTLEC';
                break;
            case 'E' :
                compagny = 'BTLEC EST';
                break;
            case 'C' :
            case 'M' :
                const scaLetter = documentName[6];
                compagny = scaMatch[scaLetter];
                break;
            case 'D' :
                compagny = 'DEVINLEC - Bijouterie';
                break;
            default :
                break;
        }
        return {
            name: compagny,
            code: compagnyMatch[compagny],
        }
    }

    /** When user press 'Enter' in the search bar, search */
    function handleKeydown(event) {
        if (event.keyCode === 13) {
            search();
        }
    }

    /**
     * search using the given values
     */
    function search() {
        campaigns = [];
        for (let i = 0; i < allCampaigns.length; i++) {
            const item = allCampaigns[i];
            let rangeOk: boolean = false;
            let searchOk: boolean = false;
            let typeOk: boolean = false;
            let centraleOk: boolean = false;
            let searchValueNorm;
            let itemNameNorm;
            let itemCodeNorm;
            if (searchValue) {
                searchValueNorm = searchValue.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                itemNameNorm = item.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                if (item.code) {
                    itemCodeNorm = item.code.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                }
            }

            if (
                new Date(item.startDate) > new Date(bottomDateRange) &&
                new Date(item.startDate) < new Date(topDateRange)
            ) {
                rangeOk = true;
            }
            if (
                !searchValue ||
                (searchValue &&
                    (itemNameNorm.toLowerCase().includes(searchValueNorm.toLowerCase()) ||
                        itemCodeNorm?.toLowerCase().includes(searchValueNorm.toLowerCase())))
            ) {
                searchOk = true;
            }
            if (
                operationTypeFilterValue === "Tous les types" ||
                operationTypeFilterValue === item.type
            ) {
                typeOk = true;
            }
            if (
                centraleFilterValue === "Toutes les centrales" ||
                (item as any).centrales?.includes(centraleFilterValue)
            ) {
                centraleOk = true;
            }
            if (rangeOk && searchOk && typeOk && centraleOk) {
                campaigns.push(item);
            }
        }
        campaigns = campaigns;
    }

    function displayMsg() {
        displayWarningMsg = true;
        warningMsg = "Les dates ont été changées. Rafraichissez la liste avec le boutton pour prendre en compte les nouvelles opérations."
    }

    function searchDebounce() {
        clearTimeout(timer);
        timer = setTimeout(() => {
            search();
        }, 250);
    }

    function displayCentrales(operation: Operation) {
        currentCampaign = operation;
        isModalOpen = true;
        centraleModal.classList.add("is-active");
    }

    function closeModal() {
        centraleModal.classList.remove("is-active");
        documentModal.classList.remove("is-active");
        productModal.classList.remove("is-active");
        isModalOpen = false;
    }

    function displayDocuments(operation: any) {
        currentCampaign = operation;
        operation.totalPages = operation.documents.reduce((partialSum, doc) => partialSum + doc.pages.length, 0)
        isModalOpen = true;
        documentModal.classList.add("is-active");
    }

    async function displayProducts(operation: any) {
        currentCampaign = operation;
        isModalOpen = true;
        productModal.classList.add("is-active");
    }

</script>

<div>
    {#if isInit}
        <div class="columns">
            <div class="column is-narrow">
                <span>Opérations du
                    <input type="date" bind:value={bottomDateRange} max={topDateRange} on:change={() => displayMsg()}/>
                    au
                    <input type="date" bind:value={topDateRange} min={bottomDateRange} on:change={() => displayMsg()}/>
                </span>
            </div>
            <div class="column is-narrow">
                <button title="rechercher" class="button btn-elpev" on:click={() => getCampaigns()}>
                    <span>Rechercher</span>
                </button>
            </div>
            <div class="column has-text-right">
                <div>
                    <button title="Exporter en csv" class="button btn-elpev" disabled={campaigns.length === 0}
                            on:click={() => exportCSV()}>
                        <span>Exporter Stats</span>
                    </button>
                </div>
            </div>
            <div class="column is-narrow has-text-right">
                <div>
                    <button title="Exporter en csv" class="button btn-elpev" disabled={campaigns.length === 0}
                            on:click={() => exportInvoice()}>
                        <span>Exporter Facture</span>
                    </button>
                </div>
            </div>
        </div>

        {#if displayWarningMsg}
            <div class="notification is-warning"><span
                    class="fas fa-exclamation-triangle"></span>&nbsp;<span>{warningMsg}</span></div>
        {/if}

        <div class="columns is-align-items-center">
            <div class="column is-two-thirds">
                <input
                        class="input"
                        type="text"
                        placeholder="Nom / Code Opération"
                        bind:value={searchValue}
                        on:keydown={handleKeydown}
                        on:keyup={() => searchDebounce()}
                />
            </div>
            <div class="column">
                <div class="select is-fullwidth">
                    <select bind:value={operationTypeFilterValue} on:change={() => search()}>
                        {#each operationTypeValues as typeValue}
                            <option value={typeValue}>{typeValue}</option>
                        {/each}
                    </select>
                </div>
            </div>
            <div class="column">
                <div class="select is-fullwidth">
                    <select bind:value={centraleFilterValue} on:change={() => search()}>
                        {#each centralesValues as centraleValue}
                            <option value={centraleValue}>{centraleValue}</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>

        <div class="columns list-result">
            <div class="column">
                {campaigns.length} {campaigns.length > 1 ? "résultats" : "résultat"}
            </div>
        </div>

        {#if campaigns.length > 0}
            <div class="columns header-mobile">
                <div class="column">
                    <b>Opération</b>
                </div>
                <div class="column">
                    <b>Dates</b>
                </div>
                <div class="column">
                    <b>Type</b>
                </div>
                <div class="column">
                    <b>Feuilletable</b>
                </div>
                <div class="column">
                    <b>Documents</b>
                </div>
                <div class="column">
                    <b>Centrales</b>
                </div>
                <div class="column">
                    <b>Nombre Magasins</b>
                </div>
                <div class="column">
                    <b>Produits</b>
                </div>
                <div class="column">
                    <b> Produits 100% digitaux</b>
                </div>
            </div>
            {#each campaigns as campaign, i}
                <div class="campaign-line columns {i % 2 === 0 ? 'bg-white' : ''}">
                    <div class="column">
                        {campaign.code} - {campaign.name}
                    </div>
                    <div class="column">
                        Du {moment(campaign.startDate).format("DD/MM/YYYY")}
                        <br/>
                        Au {moment(campaign.endDate).format("DD/MM/YYYY")}
                    </div>
                    <div class="column">
                        {campaign.type}
                    </div>
                    <div class="column">
                        {campaign.is_paf ? "Oui" : "Non"}
                    </div>
                    <div class="column">
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a on:click={() => displayDocuments(campaign)}><strong>{campaign.campaign.num_documents}</strong> {campaign.campaign.num_documents > 1 ? "documents" : "document"}
                        </a>
                    </div>
                    <div class="column">
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a on:click={() => displayCentrales(campaign)}><strong>{campaign["centrales"].length}</strong> {campaign["centrales"].length > 1 ? "centrales" : "centrale"}
                        </a>
                    </div>
                    <div class="column">
                        <strong>{campaign["shops"]}</strong> {campaign["shops"] > 1 ? "magasins" : "magasin"}
                    </div>
                    <div class="column">
                        {#if campaign.type === "Mixte"}
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a on:click={() => displayProducts(campaign)}><strong>{campaign.campaign.num_products}</strong> {campaign.campaign.num_products > 1 ? "produits" : "produit"}
                            </a>
                        {:else}
                            <strong>{campaign.campaign.num_products}</strong> {campaign.campaign.num_products > 1 ? "produits" : "produit"}
                        {/if}
                    </div>
                    <div class="column">
                        <strong>{campaign["num_ecatOnly_products"]}</strong> {campaign["num_ecatOnly_products"] > 1 ? "produits" : "produit"}
                    </div>
                </div>
            {/each}
        {:else}
            <h1>Aucune opération ne correspond aux critères de recherche</h1>
        {/if}

        <div bind:this={centraleModal} class="modal">
            {#if isModalOpen}
                <div class="modal-background" on:click="{() => closeModal()}"/>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Opération {currentCampaign.name}</p>
                        <button class="delete" aria-label="close" on:click="{() => closeModal()}">
                    </header>
                    <section class="modal-card-body">
                        {#if currentCampaign['centrales'].length > 0}
                            {#each currentCampaign['centrales'] as centraleName}
                                <li>{centraleName}</li>
                            {/each}
                        {:else}
                            Aucune centrale sur cette opération.
                        {/if}
                    </section>
                </div>
            {/if}
        </div>

        <div bind:this={documentModal} class="modal">
            {#if isModalOpen}
                <div class="modal-background" on:click="{() => closeModal()}"/>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Opération {currentCampaign.name}</p>
                        <button class="delete" aria-label="close" on:click="{() => closeModal()}">
                    </header>
                    <section class="modal-card-body">
                        {#if currentCampaign['documents'].length > 0}
                            Nombre de pages total : <b>{currentCampaign.totalPages}</b>
                            {#each currentCampaign['documents'] as document}
                                <li>{document.name} :
                                    <b>{document.pages.length}</b> {document.pages.length > 1 ? "pages" : "page"}</li>
                            {/each}
                        {:else}
                            Aucun document sur cette opération.
                        {/if}
                    </section>
                </div>
            {/if}
        </div>


        <div bind:this={productModal} class="modal">
            {#if isModalOpen}
                <div class="modal-background" on:click="{() => closeModal()}"/>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Opération {currentCampaign.name}</p>
                        <button class="delete" aria-label="close" on:click="{() => closeModal()}">
                    </header>
                    <section class="modal-card-body">
                        Nombre de produits nationaux : <b>{currentCampaign.natProds}</b>
                        {#each Object.keys(currentCampaign['productsByCentrale']).sort() as centrale}
                            <li>{centrale} :
                                <b>{currentCampaign['productsByCentrale'][centrale]}</b> {currentCampaign['productsByCentrale'][centrale] > 1 ? "produits" : "produit"}
                            </li>
                        {/each}
                    </section>
                </div>
            {/if}
        </div>
    {/if}
</div>

<style lang="scss">
  @import "../styles/variables.scss";

  .campaign-line {
    align-items: center;
    background-color: $grey-light;

    &.bg-white {
      background-color: white;
    }

    &:not(.header) {
      &:hover {
        filter: drop-shadow(0px 2px 8px $orange);
      }
    }
  }

  .list-result {
    margin-left: auto;
    margin-top: -2em
  }

  @media (max-width: $mobile-breakpoint) {
    .header-mobile {
      display: none;
    }
  }
</style>
